import { ThemeEvents } from '@theme/events';

const SHIPPING_SELECTOR = '[data-shipping-message="true"]';
const TEXT_SELECTOR = '[data-shipping-message-text]';

const formatMoney = (cents) => {
  if (window.Shopify?.formatMoney) {
    const format = window.Shopify?.money_format || '${{amount}}';
    return window.Shopify.formatMoney(cents, format);
  }
  return `$${(cents / 100).toFixed(2)}`;
};

const parseIntSafe = (value, fallback = 0) => {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const updateMessage = async (container, cartTotalOverride, { forceFetch = false } = {}) => {
  const textEl = container.querySelector(TEXT_SELECTOR);
  if (!textEl) return;

  const threshold = parseIntSafe(container.dataset.cartThreshold);
  const productPrice = parseIntSafe(container.dataset.productPrice);
  const remainingMax = parseIntSafe(container.dataset.remainingMax, 4000);

  let cartTotal = cartTotalOverride;
  if (!forceFetch && !Number.isFinite(cartTotal)) {
    cartTotal = parseIntSafe(container.dataset.cartTotal);
  }

  if (!Number.isFinite(cartTotal)) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      cartTotal = parseIntSafe(cart?.total_price);
    } catch {
      return;
    }
  }

  container.dataset.cartTotal = String(cartTotal);

  const remainingSpend = threshold - cartTotal;
  if (!threshold || remainingSpend >= remainingMax) return;

  const combinedTotal = productPrice + cartTotal;

  let message = '';
  if (cartTotal > threshold) {
    message = 'Free shipping unlocked';
  } else if (productPrice > threshold) {
    message = 'This item ships free';
  } else if (combinedTotal > threshold) {
    message = 'Add this item to get free shipping';
  } else {
    message = `Spend ${formatMoney(remainingSpend)} more for free shipping`;
  }

  textEl.textContent = message;
};

const updateAll = (cartTotalOverride, opts) => {
  document.querySelectorAll(SHIPPING_SELECTOR).forEach((container) => {
    updateMessage(container, cartTotalOverride, opts);
  });
};

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  const cartTotal = event?.detail?.resource?.total_price;
  updateAll(cartTotal, { forceFetch: !Number.isFinite(cartTotal) });
});

document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const productId = event?.detail?.data?.productId;
  const price = event?.detail?.resource?.price;
  if (!productId || !Number.isFinite(price)) return;

  document.querySelectorAll(SHIPPING_SELECTOR).forEach((container) => {
    if (container.dataset.productId !== String(productId)) return;
    container.dataset.productPrice = String(price);
    updateMessage(container);
  });
});

updateAll();
